import React from "react";
import EasyTrans from "../components/bundel/EasyTrans";
import { Button } from "../components/ui";

const Exception404Page = () => {
  return (
    <section className="relative flex min-h-[70vh] items-center justify-center overflow-hidden bg-gradient-to-b from-fairgray via-white to-white px-4 py-16">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 overflow-hidden"
      >
        <div className="absolute -top-24 -left-20 h-72 w-72 rounded-full bg-fairbrightgreen/20 blur-3xl" />
        <div className="absolute -bottom-24 right-0 h-80 w-80 rounded-full bg-fairblue-200/30 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-screen-sm text-center">
        <h1 className="mb-4 text-7xl font-extrabold tracking-tight text-fairblue-500 lg:text-9xl">
          <EasyTrans>ErrorHandling.404.CodeDescription</EasyTrans>
        </h1>
        <p className="mb-4 text-3xl font-bold tracking-tight text-gray-900 md:text-4xl">
          <EasyTrans>ErrorHandling.404.Header</EasyTrans>
        </p>
        <p className="mb-8 text-lg font-light text-gray-500">
          <EasyTrans>ErrorHandling.404.Text</EasyTrans>
        </p>
        <div className="flex flex-col justify-center gap-3 sm:flex-row">
          <a href="/" className="sm:w-auto">
            <Button variant="primary" size="lg" fullWidth>
              <EasyTrans>ErrorHandling.404.standardButton</EasyTrans>
            </Button>
          </a>
          <a href="/searchworks" className="sm:w-auto">
            <Button variant="secondary" size="lg" fullWidth>
              <EasyTrans>ErrorHandling.404.secondButton</EasyTrans>
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Exception404Page;
